import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as serviceActions from '../pb-service-list/redux/actions';
import * as commonActoins from '../common/redux/actions';
import {
	TopStrip,
	KuposFooter,
	NewSearchBoxTransfer,
	KuposModalWithButtons,
	KuposInput,
	SvgHome,
	KuposErrorSuccessModal,
} from '../common';
import DateService from '../../services/dateService';
import { withTranslation, Trans } from 'react-i18next';
import i18next from 'i18next';

import common_es from '../../translations/es/common.json';
import common_en from '../../translations/en/common.json';
import CommonService from '../../services/commonService';
import NewSearchBox from '../common/NewSearchBox';
import ApiUrls from '../../services/apiUrls';
import { AppData } from '../../services';
import Theme5 from '../themes/theme5/Theme5';
import KuposHelmet from '../common/KuposHelmet';
import { Footer1, Header2 } from '../themes';
import MainFooter from '../themes/common/footer/MainFooter';
import PinPopup from '../pin-popup';

i18next.init({
	interpolation: { escapeValue: false }, // React already does escaping
	lng: localStorage.getItem('selectedLanguage') || 'es', // language to use
	resources: {
		en: {
			common: common_en, // 'common' is our custom namespace
		},
		es: {
			common: common_es,
		},
	},
});
/*
		This is the root component of your app. Here you define the overall layout
		and the container of the react router.
		You should adjust it according to the requirement of your app.
*/
var global = window;
class App extends Component {
	static propTypes = {
		home: PropTypes.object.isRequired,
		pbServiceList: PropTypes.object,
		actions: PropTypes.object.isRequired,
		children: PropTypes.node,
	};

	static defaultProps = {
		children: '',
	};
	constructor(props) {
		super(props);
		this.state = {
			newSearchKey: 1,
		};
		this.checkResetPassword();
		this.checkVerivication();
		this.OperatorId = CommonService.getParameterByName('operator_id');
		this.referralCode = CommonService.getParameterByName('referral_code');

		console.log('in construct');
	}

	checkResetPassword() {
		if (CommonService.getParameterByName('reset_password_token')) {
			this.state.showResetPasswordModal = true;
		}
	}
	checkVerivication() {
		let verification = CommonService.getParameterByName('confirmation_token');
		if (verification) {
			this.props.actions
				.accountConfirmation({ url: ApiUrls.accountConfirmation(verification) })
				.then(
					res => {
						console.log(res);
						if (res.data && res.data.status == 200) {
							this.setState({
								showSuccessModel: true,
								showSuccessStatus: true,
								showSuccessBody: 'Su cuenta ha sido confirmada con éxito',
							});
						} else if (res.data) {
							this.setState({
								showSuccessModel: true,
								showSuccessStatus: false,
								showSuccessBody: res.data.error,
							});
						}
					},
					err => {
						console.log(err);
					},
				);
		}
	}

	componentDidMount() {
		this.loadStartupData();
		this.onScroll(); //TODO
		let loginData = CommonService.getLocal('loginData');
		CommonService.storeLoginDetails(loginData, this.props.actions.setLoginData, true);
	}

	onScroll = () => {
		this.topHeader = window.document.querySelector(
			'.nav-section.home-nav-section.common-top-strip',
		);

		if (
			this.props.history.location.pathname.length > 4 &&
			!CommonService.isHome(this.props.history.location.pathname) &&
			this.props.history.location.pathname.indexOf('index.ht') < 0 &&
			this.props.history.location.pathname.indexOf('my-account') < 0 &&
			this.topHeader
		) {
			this.topStripClass = 'header-box ';
			this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
			if (CommonService.isBusOrTrain()) {
				this.setState({
					showSearchBox: true,
				});
			} else if (
				(this.props.history.location.pathname.indexOf('transfer/') > -1 ||
					this.props.history.location.pathname.indexOf('traslados/') > -1) &&
				this.props.history.location.pathname.indexOf('/payment') <= -1 &&
				this.props.history.location.pathname.indexOf('/booking') <= -1
			) {
				this.setState({
					showSearchBoxTransfer: true,
				});
			} else {
				this.topStripClass = 'header-box  payments-page-header';
				this.topHeader.className =
					'nav-section home-nav-section common-top-strip header-box payments-page-header';
			}
		} else if (
			this.props.history.location.pathname.indexOf('my-account') >= 0 ||
			this.props.history.location.pathname.length <= 3 ||
			CommonService.isHome(this.props.history.location.pathname) ||
			this.props.history.location.pathname.indexOf('index.ht') > -1
		) {
			this.topStripClass = '';
			this.topHeader.className = 'nav-section home-nav-section common-top-strip '; //Todo
			this.setState({
				logoType: 1,
			});
		} else {
			this.topStripClass = 'header-box  payments-page-header';
			this.topHeader.className =
				'nav-section home-nav-section common-top-strip header-box payments-page-header';
		}

		window.addEventListener('scroll', event => {
			const operator = CommonService.getLocal('op');
			var scroll = event.currentTarget.scrollY;
			var menu = window.document.querySelector('.home-banner');
			var menuSearch = window.document.querySelector('.common-new-search-box');
			if (menuSearch) {
				if (scroll > 60) {
					menuSearch.className = 'common-new-search-box hide-searchbox';
					this.props.pbServiceList.openNewSearch
						? this.props.actions.openCloseNewSearch(false)
						: null;
				} else {
					menuSearch.className = 'common-new-search-box';
				}
			}

			if (
				this.props.history.location.pathname.indexOf('booking') > -1 ||
				this.props.history.location.pathname.indexOf('/payment') > -1
			) {
				let paymentSideBar = document.querySelector('.pb-payment-details-payment-right-side-bar');
				let paymentPageContent = document.querySelector('.pb-service-list-payment-details-page');
				if (paymentSideBar) {
					if (
						(paymentPageContent.getBoundingClientRect().top <= this.topHeader.clientHeight + 25 &&
							paymentPageContent.getBoundingClientRect().bottom >
							paymentSideBar.getBoundingClientRect().bottom + 30) ||
						(paymentSideBar.getBoundingClientRect().top > this.topHeader.clientHeight + 25 &&
							paymentSideBar.className ==
							'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details')
					) {
						if (
							paymentSideBar.className !=
							'pb-payment-details-payment-right-side-bar journey-summary-sidebar fixed-fare-details'
						) {
							paymentSideBar.className = operator && operator.operator_name === 'arzola' ? 'pb-payment-details-payment-right-side-bar journey-summary-sidebar fixed-fare-details arz-icons' :
								'pb-payment-details-payment-right-side-bar journey-summary-sidebar fixed-fare-details';
						}
					} else if (
						paymentPageContent.getBoundingClientRect().bottom <=
						paymentSideBar.getBoundingClientRect().bottom + 30
					) {
						if (
							paymentSideBar.className !=
							'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details'
						) {
							paymentSideBar.className = operator && operator.operator_name === 'arzola' ? 'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details arz-icons' :
								'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details';
						}
					} else {
						if (
							paymentSideBar.className !=
							'pb-payment-details-payment-right-side-bar journey-summary-sidebar'
						) {

							paymentSideBar.className = operator && operator.operator_name === 'arzola' ? 'pb-payment-details-payment-right-side-bar journey-summary-sidebar arz-icons' :
								'pb-payment-details-payment-right-side-bar journey-summary-sidebar';
						}
					}
				}
			} else if (CommonService.isBusOrTrain() || CommonService.isBusOrTrain()) {
				let filterBar = document.querySelector('.pb-service-list-service-filter');
				let servicePageContent = document.querySelector('.services-list-container');
				let header = document.querySelector('.header-details');
				if (filterBar) {
					if (
						(servicePageContent.getBoundingClientRect().top <= header.clientHeight + 25 &&
							+servicePageContent.getBoundingClientRect().bottom.toFixed(0) >
							+filterBar.getBoundingClientRect().bottom.toFixed(0)) ||
						(filterBar.getBoundingClientRect().top > header.clientHeight + 25 &&
							filterBar.className ==
							'pb-service-list-service-filter filter-container absolute-service-filters')
					) {
						if (
							filterBar.className !=
							'pb-service-list-service-filter filter-container fixed-service-filters'
						) {
							filterBar.className =
								'pb-service-list-service-filter filter-container fixed-service-filters';
							filterBar.style.top = header.clientHeight + 18 + 'px';
						}
					} else if (
						+servicePageContent.getBoundingClientRect().bottom.toFixed(0) <=
						+filterBar.getBoundingClientRect().bottom.toFixed(0)
					) {
						if (
							filterBar.className !=
							'pb-service-list-service-filter filter-container absolute-service-filters'
						) {
							filterBar.className =
								'pb-service-list-service-filter filter-container absolute-service-filters';
							filterBar.style.top = 'initial';
						}
					} else {
						if (filterBar.className != 'pb-service-list-service-filter filter-container') {
							filterBar.className = 'pb-service-list-service-filter filter-container';
							filterBar.style.top = 0;
						}
					}
				}
			}
			if (menu) {
				if (
					!(
						this.props.history.location.pathname.length > 4 &&
						!CommonService.isHome(this.props.history.location.pathname) &&
						this.props.history.location.pathname.indexOf('index.ht') < 0 &&
						this.props.history.location.pathname.indexOf('my-account') < 0
					)
				) {
					if (
						(scroll > menu.clientHeight - 220 &&
							this.props.history.location.pathname.indexOf('my-account') < 0) ||
						(scroll > menu.clientHeight - 100 &&
							this.props.history.location.pathname.indexOf('my-account') >= 0)
					) {
						if (!this.topStripClass) {
							this.topStripClass = 'header-box  payments-page-header';
							this.topHeader.className !=
								'nav-section home-nav-section common-top-strip header-box payments-page-header'
								? (this.topHeader.className =
									'nav-section home-nav-section common-top-strip header-box payments-page-header')
								: null;
							// this.setState({ scroll: true });
						}
						if (this.logoType != 2) {
							this.logoType = 2;
							this.setState({
								logoType: 2,
							});
						}
					} else {
						if (this.topStripClass) {
							this.topStripClass = '';
							this.topHeader.className != 'nav-section home-nav-section common-top-strip'
								? (this.topHeader.className = 'nav-section home-nav-section common-top-strip')
								: null;
							// this.setState({ scroll: true });
						}
						if (this.logoType != 1) {
							this.logoType = 1;
							this.setState({
								logoType: 1,
							});
						}
					}
				} else if (this.props.history.location.pathname.indexOf('my-account') >= 0) {
					// if (scroll > 300) {
					//   this.topStripClass = 'header-box  payments-page-header';
					//   this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box payments-page-header';
					// } else {
					//   this.topStripClass = '';
					//   this.topHeader.className = 'nav-section home-nav-section common-top-strip';
					// }
				} else if (
					this.props.history.location.pathname.length <= 4 ||
					CommonService.isHome(this.props.history.location.pathname) ||
					this.props.history.location.pathname.indexOf('index.ht') > -1
				) {
					if (scroll > 300) {
						this.topStripClass = 'header-box  payments-page-header';
						this.topHeader.className = 'header-box payments-page-header';
					} else {
						this.topStripClass = '';
						this.topHeader.className = 'nav-section home-nav-section common-top-strip '; // Todo
					}
				}
			}
		});
	};

	componentWillUpdate() {
		var menuSearch = window.document.querySelector('.common-new-search-box');
		if (menuSearch) {
			let scroll = window.pageYOffset;
			if (scroll > 60) {
				menuSearch.className = 'common-new-search-box hide-searchbox';
				this.props.pbServiceList.openNewSearch
					? this.props.actions.openCloseNewSearch(false)
					: null;
			} else {
				menuSearch.className = 'common-new-search-box';
			}
		}

		const operator = CommonService.getLocal('op');

		if (window.location.pathname === '/') {
			this.topHeader.className = 'nav-section home-nav-section common-top-strip ';
			if ((operator && operator.theme_type === 5) || (operator && operator.theme_type === 4)) {
				// console.log('----------------theme-5-header-config', operator)
				this.topHeader.className =
					'nav-section home-nav-section common-top-strip theme-5-header-config';
			} else if (operator && operator.operator_name === 'ivergrama') {
				// console.log('----------------theme-5-header-config', operator)
				this.topHeader.className =
					'nav-section home-nav-section common-top-strip relative-nav-section';
			}
		}

		if (
			this.props.history.location.pathname.length > 4 &&
			!CommonService.isHome(this.props.history.location.pathname) &&
			this.props.history.location.pathname.indexOf('index.ht') < 0 &&
			this.props.history.location.pathname.indexOf('my-account') < 0 &&
			this.topHeader
		) {
			this.topStripClass = 'header-box';
			this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
			if (this.logoType != 2) {
				this.logoType = 2;
				this.setState({
					logoType: 2,
				});
			}
			if (CommonService.isBusOrTrain()) {
				if (!this.showSearchBox) {
					this.showSearchBox = true;
					this.setState({
						showSearchBox: true,
					});
				}
				// this.topStripClass = 'header-box';
				// this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
				this.pbSourceCity =
					this.pbSourceCity || (this.props.home.pbSourceCity && this.props.home.pbSourceCity.label);
				this.pbDestinationCity =
					this.pbDestinationCity ||
					(this.props.home.pbDestinationCity && this.props.home.pbDestinationCity.label);
				this.pbOnwardDate =
					this.pbOnwardDate ||
					(this.props.home.onwardPBDate &&
						DateService.getDayNameFromDate(this.props.home.onwardPBDate) +
						', ' +
						DateService.getDateFromDate(this.props.home.onwardPBDate) +
						' ' +
						DateService.getMonthNameFromDate(this.props.home.onwardPBDate));
				this.pbReturnDate =
					this.pbReturnDate ||
					(this.props.home.returnPBDate &&
						DateService.getDayNameFromDate(this.props.home.returnPBDate) +
						', ' +
						DateService.getDateFromDate(this.props.home.returnPBDate) +
						' ' +
						DateService.getMonthNameFromDate(this.props.home.returnPBDate));
			} else if (
				(this.props.history.location.pathname.indexOf('transfer/') > -1 ||
					this.props.history.location.pathname.indexOf('traslados/') > -1) &&
				this.props.history.location.pathname.indexOf('/payment') <= -1 &&
				this.props.history.location.pathname.indexOf('/booking') <= -1
			) {
				if (!this.showSearchBoxTransfer) {
					this.showSearchBoxTransfer = true;
					this.setState({
						showSearchBoxTransfer: true,
					});
				}
				// this.topStripClass = 'header-box';
				// this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
				this.service =
					this.service ||
					(this.props.home.transferData.service && this.props.home.transferData.service.label);
				this.origin =
					this.origin ||
					(this.props.home.transferData.origin && this.props.home.transferData.origin.label);
				this.date =
					this.date ||
					(this.props.home.transferData.date && this.props.home.transferData.date.label);
				this.time =
					this.time ||
					(this.props.home.transferData.time && this.props.home.transferData.time.label);
				this.kupos =
					this.kupos ||
					(this.props.home.transferData.kupos && this.props.home.transferData.kupos.label);
			} else {
				if (
					!(
						this.props.history.location.pathname.indexOf('my-account') >= 0 ||
						this.props.history.location.pathname.indexOf('bus') >= 0 ||
						this.props.history.location.pathname.length <= 4 ||
						CommonService.isHome(this.props.history.location.pathname) ||
						this.props.history.location.pathname.indexOf('index.ht') > -1
					)
				) {
					// ThemeSeven Header Config if this doesn't work then remove this
					if (
						this.props.home.operator &&
						this.props.home.operator.theme_type === 7 &&
						!this.props.history.location.pathname.includes('booking')
					) {
						this.topHeader.className =
							'nav-section home-nav-section common-top-strip theme-seven-header-config  remove-boxshadow';
					} else {
						this.topStripClass = 'header-box  payments-page-header';
						this.topHeader.className =
							'nav-section home-nav-section common-top-strip header-box payments-page-header remove-boxshadow';
					}
				}
				if (this.showSearchBox) {
					this.showSearchBox = false;
					this.setState({ showSearchBox: false });
				}
				if (this.showSearchBoxTransfer) {
					this.showSearchBoxTransfer = false;
					this.setState({ showSearchBoxTransfer: false });
				}
			}
		} else if (
			this.props.history.location.pathname.indexOf('my-account') >= 0 ||
			this.props.history.location.pathname.length <= 4 ||
			CommonService.isHome(this.props.history.location.pathname) ||
			this.props.history.location.pathname.indexOf('index.ht') > -1
		) {
			setTimeout(() => {
				var menu = window.document.querySelector('.home-banner');
				let scroll = window.pageYOffset;
				if (menu) {
					if (
						(scroll > menu.clientHeight - 220 &&
							this.props.history.location.pathname.indexOf('my-account') < 0) ||
						(scroll > menu.clientHeight - 100 &&
							this.props.history.location.pathname.indexOf('my-account') >= 0)
					) {
						this.topStripClass = 'header-box  payments-page-header';
						this.topHeader.className !=
							'nav-section home-nav-section common-top-strip header-box payments-page-header'
							? (this.topHeader.className =
								'nav-section home-nav-section common-top-strip header-box payments-page-header')
							: null;
						// this.setState({ scroll: true });
						if (this.logoType != 2) {
							this.logoType = 2;
							this.setState({
								logoType: 2,
							});
						}
					} else {
						this.topStripClass = '';
						this.topHeader.className != 'nav-section home-nav-section common-top-strip'
							? (this.topHeader.className = 'nav-section home-nav-section common-top-strip')
							: null;
						// this.setState({ scroll: true });
						if (this.logoType != 1) {
							this.logoType = 1;
							this.setState({
								logoType: 1,
							});
						}
					}
				}
				if (this.showSearchBox) {
					this.showSearchBox = false;
					this.setState({ showSearchBox: false });
				}
				if (this.showSearchBoxTransfer) {
					this.showSearchBoxTransfer = false;
					this.setState({ showSearchBoxTransfer: false });
				}
			}, 150);
		} else {
		}
	}

	loadStartupData = () => {
		// this.props.actions.getMetaData();
		// this.props.actions.getMetaData();
		console.log('inside loadStartupData');
		// this.props.actions.getUniqueCities({ type: 'train' });

		this.props.actions.setCities(
			CommonService.formatCities(JSON.parse(localStorage.getItem('citiesList') || '[]')),
		);

		if (localStorage.getItem('metaData') != 'undefined') {
			this.props.actions.setMetaData(JSON.parse(localStorage.getItem('metaData') || '{}'));
		}

		// if (localStorage.getItem('loginData') != 'undefined') {
		//   let loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
		//   console.log("loginData in appjs", loginData)
		//   global.token = loginData && loginData.auth_token;
		// }

		this.props.actions.getMetaData().then(
			res => {
				console.log('response in metadata', res.data.result.carpool.key);
				if (res && res.data) {
					localStorage.setItem('metaData', JSON.stringify(res.data.result));
					localStorage.setItem('jwt_key', res.data.jwt_secret);
					global.xkey = res.data.result.carpool.key;
					console.log('getMetaData metaSecret', res, CommonService.metaSecret(res.data.jwt_secret));
					CommonService.metaSecret(res.data.jwt_secret);
					CommonService.akd(res.data.x_auth_key);
				}
				// Fetch operator site details
				this.props.actions
					.apiCall({
						url: AppData.BASE_URL + 'api/operator_site_details',
						type: 'home',
					})
					.then(
						res => {
							this.onOperatorFetch(res);

							// If the operator name from the API response is "centropuerto"
							if (res.data && res.data.operator ) {
								this.props.actions
									.apiCall({
										url: AppData.BASE_URL + 'api/operators_data',
										type: 'home',
									})
									.then(
										res => {
											console.log("hello", res), sessionStorage.setItem("centropuertoOperatorData", JSON.stringify(res.data))
										},
										err => (console.log("hello", err)),
									);
							}
						},
						err => this.onOperatorFetch(err),
					);

				// Fetch stage details (twice as per the original code)
				this.props.actions
					.apiCall({
						url: AppData.BASE_URL + 'api/stage_details',
						type: 'home',
					})
					.then(
						res => this.onStagesFetch(res),
						err => this.onStagesFetch(err),
					);


			},
			err => this.onStagesFetch(err),
		);


		// this.props.actions
		//   .apiCall({
		//     url: AppData.BASE_URL + 'api/site_map',
		//     type: 'home',
		//   })
		//   .then(
		//     res => this.onSitemapFetch(res),
		//     err => this.onSitemapFetch(err),
		//   );

		//GET AIRPORT TERMIANLS
		// this.props.actions
		//   .apiCall({
		//     url: AppData.AT_URL + 'api/v1/airportLocations',
		//     // type: 'home',
		//     method: 'GET',
		//   })
		//   .then(
		//     res => this.onAirportTerminalsFetch(res),
		//     err => console.log('Issue in fetching AT terminals', err),
		//   );

		//GET AT SEAT TYPES
		// this.props.actions
		//   .apiCall({
		//     url: AppData.AT_URL + 'api/v1/master_data/SEAT/TYPE',
		//     // type: 'home',
		//     method: 'GET',
		//   })
		//   .then(
		//     res => this.onGetATSeatDetails(res),
		//     err => this.onGetATSeatDetails(err),
		//   );

		//GET AT SEAT TYPES
		// this.props.actions
		//   .apiCall({
		//     url: AppData.AT_URL + 'api/v1/master_data/INTERVAL/DELFOS_BOOKING',
		//     // type: 'home',
		//     method: 'GET',
		//   })
		//   .then(
		//     res => this.onGetATBlockPeriod(res),
		//     err => this.onGetATBlockPeriod(err),
		//   );
	};

	onOperatorFetch = result => {
		console.log('onOperatorFetch ----------------', result);

		if (result && result.data && result.data.operator) {
			this.props.actions.setOperatorSite(result.data.operator);
			CommonService.setLocal('op', result.data.operator);
			// fetch the city list based on operator_id
			// this.props.actions.getUniqueCities({ operator: result.data.operator.operator_id });

			if (result.data.operator.operator_name === 'centropuerto') {
				//
				this.props.actions.getUniqueCitiesTheme11().then(
					res => {
						localStorage.setItem('citiesList', JSON.stringify(res.data.data.cities));

						this.props.actions.setCities({
							type: 'bus',
							data: CommonService.formatCitiesTheme11(res.data.data.cities),
						});
					},
					err => { },
				);
			} else {
				this.props.actions.getUniqueCities({ operator: result.data.operator.operator_id }).then(
					res => {
						localStorage.setItem('citiesList', JSON.stringify(res.data));

						this.props.actions.setCities({
							type: 'bus',
							data: CommonService.formatCities(res.data),
						});
					},
					err => { },
				);
			}
		} else {
			CommonService.setLocal('op', null);
		}
	};

	onAirportTerminalsFetch = res => {
		// console.log('Airport locations result--', res);
		if (res && res.data && res.data.success && res.data.data) {
			this.setState({ ATTerminals: res.data.data });
			this.props.actions.setAtMastersData({
				type: 'terminals',
				data: res.data.data,
			});
		}
	};

	// onGetATSeatDetails = res => {
	//   if (res && res.data && res.data.success && res.data.data) {
	//     this.props.actions.setAtMastersData(res.data.data);
	//   }
	// };

	// onGetATBlockPeriod = res => {
	//   if (res && res.data && res.data.success && res.data.data) {
	//     this.props.actions.setAtMastersData({ type: 'block_time', data: res.data.data });
	//   }
	// };

	onStagesFetch = result => {
		if (result && result.status) {
			let data = CommonService.copyObject(result.data);
			data = Object.entries(data);
			let stage = {};
			for (let k of data) {
				// console.log("console k", k)
				const id = k[0];

				const label = k[0][1];
				stage[id] = label;
			}

			this.props.actions.setTerminals(stage);
			// 	 console.log('Stages fetch data ----------------', result);
			// if (result && result.data && result.data.body) {
			//   this.props.actions.setTerminals(result.data.body);
			// }
		}
	};

	onSitemapFetch = result => {
		// console.log('Sitemap fetch data ----------------', result);
		if (result && result.data) {
			this.props.actions.setSiteMapData(result.data);
		}
	};

	newSearch = () => {
		this.setState({ newSearchKey: this.state.newSearch + 1 });
		this.pbSourceCity = this.props.home.pbSourceCity && this.props.home.pbSourceCity.label;
		this.pbDestinationCity =
			this.props.home.pbDestinationCity && this.props.home.pbDestinationCity.label;
		this.pbOnwardDate =
			this.props.home.onwardPBDate &&
			DateService.getDayNameFromDate(this.props.home.onwardPBDate) +
			', ' +
			DateService.getDateFromDate(this.props.home.onwardPBDate) +
			' ' +
			DateService.getMonthNameFromDate(this.props.home.onwardPBDate);
		this.pbReturnDate =
			this.props.home.returnPBDate &&
			DateService.getDayNameFromDate(this.props.home.returnPBDate) +
			', ' +
			DateService.getDateFromDate(this.props.home.returnPBDate) +
			' ' +
			DateService.getMonthNameFromDate(this.props.home.returnPBDate);
		CommonService.newSearchFunction();
	};

	newSearchTransfer = () => {
		CommonService.newSearchTranserFunction();
	};

	// onTransferChange = (val, type) => {
	//   console.log('External data change is----', val, type);
	//   switch (type) {
	//     case 'service':
	//       this.props.actions.setTransferData({
	//         selectedService: { value: val.value, label: this.props.t(val.label) },
	//       });
	//       break;
	//     case 'origin':
	//       this.props.actions.setTransferData({ selectedOrigin: val });
	//       break;
	//     case 'date':
	//       this.props.actions.setTransferData({ selectedDate: val });
	//       break;
	//     case 'time':
	//       this.props.actions.setTransferData({ selectedTime: val });
	//       break;
	//     case 'kupos':
	//       this.props.actions.setTransferData({ selectedKupos: val });
	//       break;

	//     default:
	//       break;
	//   }
	// };

	onTransferChange = (val, type) => {
		console.log('On chage data is---------', val, type);
		switch (type) {
			// case 'service':
			//   this.props.actions.setTransferData({
			//     selectedService: { value: val.value, label: this.props.t(val.label) },
			//   });
			//   break;
			case 'origin':
				this.props.actions.setTransferData({ selectedOrigin: val });
				break;
			case 'destination':
				this.props.actions.setTransferData({ selectedDestination: val });
				break;
			case 'date':
				this.props.actions.setTransferData({ selectedDate: val });
				break;
			case 'time':
				this.props.actions.setTransferData({ selectedTime: val });
				break;
			case 'start_date':
				this.props.actions.setTransferData({ selectedStartDate: val });
				break;
			case 'end_date':
				this.props.actions.setTransferData({ selectedEndDate: val });
				break;
			case 'start_time':
				this.props.actions.setTransferData({ selectedStartTime: val });
				break;
			case 'end_time':
				this.props.actions.setTransferData({ selectedEndTime: val });
				break;
			case 'kupos':
				this.props.actions.setTransferData({ selectedKupos: val });
				break;
			case 'kupos_adult':
				// console.log('last point of setting searchbox kupos_adult', val);
				this.setState({
					selectedAdultKupos: Number(val) < 1 ? 1 : Number(val),
					selectedKupos:
						Number(val) < 1 ? 1 : Number(val) + Number(this.state.selectedKidKupos || 0),
				});
				break;
			case 'kupos_kid':
				// console.log('last point of setting searchbox kupos_kid', val);
				this.setState({
					selectedKidKupos: val < 1 ? 0 : Number(val),
					selectedKupos: Number(this.state.selectedAdultKupos || 1) + Number(val),
				});
				break;
			case 'kupos_infant':
				this.props.actions.setTransferData({ selectedInfantKupos: val < 0 ? 0 : val });
				break;

			default:
				break;
		}

		if (type === 'kupos_adult' || type === 'kupos_kid') {
			if (type === 'kupos_adult') {
				this.props.actions.setTransferData({ selectedAdultKupos: val < 1 ? 1 : val });
			} else {
				this.props.actions.setTransferData({ selectedKidKupos: val < 0 ? 0 : val });
			}

			setTimeout(() => {
				this.props.actions.setTransferData({ selectedKupos: this.state.selectedKupos });
			}, 500);
		}
	};

	renderMainLoader = () => {
		return (
			<div className="main-app-loader content-container">
				<span>Loading..</span>
			</div>
		);
	};

	swapCities = () => {
		let source = CommonService.copyObject(this.props.home.pbSourceCity);
		let dest = CommonService.copyObject(this.props.home.pbDestinationCity);
		this.props.actions.pbSetSourceCity(dest);
		this.props.actions.pbSetDestinationCity(source);
	};

	onLogoClicked = () => {
		if (
			this.props.history.location.pathname.length == 1 ||
			this.props.history.location.pathname.indexOf('index.ht') >= 0
		) {
			window.location.reload();
		}
	};

	resetPassword = () => {
		console.log(this, 'props');
		let errorCount = 0;
		if (!this.state.resetPassword) {
			this.setState({
				resetPasswordError: 'VALIDATIONS.VALID_PASSWORD',
			});
			errorCount++;
		} else {
			if (this.state.resetPassword.length < 8) {
				this.setState({
					resetPasswordError: 'VALIDATIONS.VALID_PASSWORD_LENGTH',
				});
			}
		}
		if (this.state.resetPassword != this.state.resetConfirmPassword) {
			this.setState({
				resetConfirmPasswordError: 'VALIDATIONS.VALID_CONFIRM_PASSWORD',
			});
		}
		if (errorCount > 0) {
			return;
		}
		let data = {
			user: {
				password: this.state.resetPassword,
				password_confirmation: this.state.resetConfirmPassword,
				reset_password_token: CommonService.getParameterByName('reset_password_token'),
			},
		};
		this.props.actions
			.resetNewPassword({
				url: ApiUrls.resetNewPassword(CommonService.getParameterByName('reset_password_token')),
				data: data,
			})
			.then(
				res => {
					console.log(res);
					if (res.data && res.data.status == 200) {
						this.setState({
							showSuccessModel: true,
							showSuccessStatus: true,
							showSuccessBody: 'Tu contraseña ha sido actualizada.',
							showResetPasswordModal: false,
						});
					} else if (res.data) {
						this.setState({
							showSuccessModel: true,
							showSuccessStatus: false,
							showSuccessBody: res.data.error,
						});
					}
				},
				err => {
					console.log(err);
				},
			);
	};

	render() {
		const { t, i18n } = this.props;
		// op stands for operator_sites
		// const operator = CommonService.getLocal('op')||this.props.home.operator;
		const font_family =
			this.props.home.operator && this.props.home.operator.font_family
				? this.props.home.operator.font_family
				: '';

		// <KuposHelmet />;
		// console.log('showSearchBox===============', this.state.showSearchBox);
		sessionStorage.removeItem('paymentGatewaySelected');
		return (
			<div className={'home-app ' + font_family}>
				<PinPopup />
				<TopStrip
					t={t}
					i18n={i18n}
					// classes={this.topStripClass}
					logoType={this.state.logoType}
					history={this.props.history}
					metaData={this.props.home.metaData}
					onLogoClicked={this.onLogoClicked}
					// key={(this.props.home.pbSourceCity || {}).value + (this.props.home.pbDestinationCity || {}).value}
					newSearch={
						this.state.showSearchBox ? (
							<NewSearchBox
								cities={
									CommonService.isTrain()
										? this.props.home.uniqueCitiesTrain
										: this.props.home.uniqueCities
								}
								openNewSearch={this.props.pbServiceList.openNewSearch}
								pbSourceCity={this.props.home.pbSourceCity}
								sourceCityOnChange={this.props.actions.pbSetSourceCity}
								pbDestinationCity={this.props.home.pbDestinationCity}
								destinationCityOnChange={this.props.actions.pbSetDestinationCity}
								onwardPBDate={this.props.home.onwardPBDate}
								onwardDateChange={this.props.actions.setOnwardPbDate}
								returnPBDate={this.props.home.returnPBDate}
								returnDateChange={this.props.actions.setReturnPbDate}
								swapCities={this.swapCities}
								newSearch={this.newSearch}
								t={t}
								key={this.state.newSearchKey}
							/>
						) : this.state.showSearchBoxTransfer ? (
							<NewSearchBoxTransfer
								cities={this.props.home.uniqueCities}
								openNewSearch={this.props.pbServiceList.openNewSearch}
								transferData={this.props.home.transferData}
								newSearch={this.newSearchTransfer}
								onChange={this.onTransferChange}
								t={t}
								alignItems={'inherit'}
								seatTypes={this.props.home.atMastersData}
								key={
									this.props.home.transferData.selectedOrigin
										? this.props.home.transferData.selectedOrigin.address
										: ''
								}
								home={this.props.home}
							/>
						) : null
					}
				></TopStrip>
				{/* {!this.props.home ? this.renderMainLoader() : this.props.children}//TODO */}
				{/* {operator ? */}
				{/* <Theme5 history={this.props.history} operator={operator} />//TODO */}
				{this.props.children}
				{/* //  : this.renderMainLoader()} */}
				{/* {this.props.home && this.props.home.operatorSites ? */}
				{/* <KuposFooter
          metaData={this.props.home.metaData}
          t={t}
          history={this.props.history}
          actions={this.props.actions}
          ticketDetails={this.props.common.ticketDetails}
          serviceList={this.props.pbServiceList && this.props.pbServiceList.serviceList}
          // operatorSites={this.props.home.operatorSites}
        /> */}
				{/* : null} */}
				<KuposModalWithButtons
					showModal={this.state.showResetPasswordModal}
					showButton1={false}
					size="md"
				>
					<div className="reset-modal-inp">
						<div
							className="close-button pointer"
							onClick={() => {
								this.setState({ showResetPasswordModal: false });
								this.props.history.push('/');
							}}
						>
							<SvgHome name="close" />
						</div>
						<div className="inp">
							<div className="inp-label bold-text font10">Contraseña</div>
							<KuposInput
								type="password"
								className="kupos-border"
								placeholder="Ingrese Contraseña"
								onChange={text => this.setState({ resetPassword: text, resetPasswordError: null })}
								onBlur={() => { }}
								value={this.state.resetPassword}
								error={this.state.resetPasswordError ? true : false}
								errorMessage={this.state.resetPasswordError}
							/>
						</div>
						<div className="inp">
							<div className="inp-label bold-text font10">Confirme Contraseña</div>
							<KuposInput
								type="password"
								className="kupos-border"
								placeholder="Confirme Contraseña"
								onChange={text =>
									this.setState({ resetConfirmPassword: text, resetConfirmPasswordError: null })
								}
								onBlur={() => { }}
								value={this.state.resetConfirmPassword}
								error={this.state.resetConfirmPasswordError ? true : false}
								errorMessage={this.state.resetConfirmPasswordError}
							/>
						</div>
						<div className=" font12">
							<button
								disabled={this.props.home.resetNewPasswordPending}
								className="kupos-button"
								onClick={this.resetPassword}
							>
								{this.props.home.resetNewPasswordPending ? (
									<div className="loader-cricle"></div>
								) : (
									<span>{this.props.t('Cambia la contraseña')}</span>
								)}
							</button>
						</div>
					</div>
				</KuposModalWithButtons>
				<KuposErrorSuccessModal
					showModal={this.state.showSuccessModel}
					success={this.state.showSuccessStatus}
					bodyText={this.state.showSuccessBody}
					onButtonClick={() =>
						this.setState({
							showSuccessModel: false,
							showSuccessModel: null,
							showSuccessBody: null,
						})
					}
				/>
				<MainFooter
					key={this.props.history.location.pathname}
					operator={this.props.home.operator}
				/>
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		pbServiceList: state.pbServiceList,
		airportTransfer: state.airportTransfer,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...serviceActions, ...commonActoins }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(App));



// WEBPACK FOOTER //
// ./src/features/home/App.js